export interface NewAccountsState {
  newAccount: NewAccount;
  bulkAccount: BulkAccount;
  previousImports: PreviousImports;
}

export interface NewAccount {
  submitting: boolean;
}

export interface BulkAccount {
  submitting: boolean;
  status: BulkAccountUploadStatus | null;
}

export interface BulkAccountUploadStatus {
  totalItems: number;
  completedItems: number;
  failedItems: number;
  pendingItems: number;
  unsuccessfulItems: ImportItems[];
}

export interface ImportItems {
  id: string;
  status: number;
  email: string;
  firstName: string;
  lastName: string;
  errorMessage: string | null;
  createdAccountId: string | null;
  subscriptionPreset: number;
}

export interface PreviousImports {
  pageNumber: number;
  pageSize: number;
  loading: boolean;
  items: PreviousImportsItems[];
  totalCount: number;
  selectedPreviousImport: PreviousImportsDetail;
}

export interface PreviousImportsItems {
  id: string;
  createdByUserUid: string | null;
  createdByUserName: string;
  status: number;
  createdAt: string;
  completedAt: string | null;
  totalItems: number;
  succeededItems: number;
  failedItems: number;
  pendingItems: number;
}

export interface PreviousImportsDetail {
  loading: boolean;
  pageSize: number;
  id: string;
  createdByUserName: string;
  createdAt: string;
  status: number;
  totalItems: number;
  succeededItems: number;
  failedItems: number;
  pendingItems: number;
  items: {
    items: ImportItems[];
  };
}

export const initialState: NewAccountsState = {
  newAccount: {
    submitting: false
  },
  bulkAccount: {
    submitting: false,
    status: null
  },
  previousImports: {
    pageNumber: 1,
    pageSize: 20,
    loading: false,
    items: [],
    totalCount: 0,
    selectedPreviousImport: {
      loading: true,
      pageSize: 40,
      id: '',
      createdByUserName: '',
      createdAt: '',
      status: 0,
      totalItems: 0,
      succeededItems: 0,
      failedItems: 0,
      pendingItems: 0,
      items: {
        items: []
      }
    }
  }
};
